// fill = e.g. "text-bidfta-blue-dark"

export default function BidLocationIcon({ fill }: any) {
  return (
    <div>
      <svg
        className={`fill-current ${fill}`}
        width="12"
        height="14"
        viewBox="0 0 12 14"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.70366 14C5.86149 14 6.07194 13.9073 6.17715 13.7682C6.38759 13.4901 11.175 7.27812 11.175 4.77481C11.175 2.13242 8.75497 0 5.75626 0C2.75754 0 0.337524 2.13242 0.337524 4.77481C0.337524 7.27812 5.12495 13.4901 5.33539 13.7682C5.388 13.9536 5.54583 14 5.70366 14ZM1.38971 4.82115C1.38971 2.73506 3.33625 1.01985 5.70366 1.01985C8.07107 1.01985 10.0176 2.73506 10.0176 4.82115C10.0176 6.3046 7.7028 9.92051 5.70366 12.6556C3.70451 9.92051 1.38971 6.3046 1.38971 4.82115Z"
          fill={fill}
        />
        <path
          d="M5.28162 2.96008C5.28162 1.70839 4.12419 0.688477 2.70374 0.688477C1.28328 0.688477 0.125854 1.70839 0.125854 2.96008C0.125854 4.21178 1.28328 5.23169 2.70374 5.23169C4.12419 5.23169 5.28162 4.21178 5.28162 2.96008ZM4.1768 2.96008C4.1768 3.70183 3.49288 4.25816 2.70374 4.25816C1.86198 4.25816 1.23067 3.65547 1.23067 2.96008C1.23067 2.2647 1.91459 1.66201 2.70374 1.66201C3.49288 1.66201 4.1768 2.21834 4.1768 2.96008Z"
          fill={fill}
          transform="translate(3,3)"
        />
      </svg>
    </div>
  )
}
